import { cn } from "@/lib/utils";
import Image from "next/image";
import type { HTMLAttributes } from "react";

export type LoaderProps = HTMLAttributes<HTMLDivElement> & {
  size?: number;
};

export const Loader = ({ className, size = 20, ...props }: LoaderProps) => (
  <div
    className={cn(
      "inline-flex items-center justify-center",
      className
    )}
    {...props}
  >
    <span
      className="rounded-lg bg-[var(--mindup-pink-light)] dark:bg-[var(--mindup-pink)]/20 p-0.5 overflow-hidden shrink-0"
      style={{ width: size + 4, height: size + 4 }}
    >
      <Image
        src="/brand/icons/sparkle.gif"
        alt="Loading"
        width={size}
        height={size}
        className="w-full h-full"
        unoptimized
      />
    </span>
  </div>
);
